const isLoading = {
    File: (state, { key }) => state.lazyOpen.files.extensions.has(key),
    Attachment: (state, { key }) => state.lazyOpen.attachments.extensions.has(key),
    EditUrl: (state, { key }) => state.lazyOpen.editUrls.extensions.has(key),
};
export default isLoading;